export const programNames = {
  "BL": "Bottom Line",
  "GSSBK": "Good Shepherd Services Brooklyn",
  "NYCOB": "NYC Outward Bound Schools",
  "OBT": "Opportunity for a Better Tomorrow",
  "NSA": "New Settlement"
};

export const getProgramIdFromName = name => Object.keys(programNames).find(key => programNames[key] === name);